import { lazy, type ComponentType } from "react";
import { isChunkLoadError, reloadForFreshShell } from "./pwa-update";

/** Suspend failed assets rather than tearing down the entire app (and forms)
 * through the root ErrorBoundary. Shared by every lazy-loaded app surface. */
export function safeLazy<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      return await load();
    } catch (error) {
      if (!isChunkLoadError(error)) throw error;
      void reloadForFreshShell("lazy-asset");
      return new Promise<{ default: T }>(() => {});
    }
  });
}
